import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import api from "../api/axios";

const SearchPage = () => {
  const [searchParams] = useSearchParams();
  const keyword = searchParams.get("query");

  const [results, setResults] = useState({
    products: [],
    brands: [],
    testimonials: [],
    teams: [],
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!keyword) return;

    const fetchResults = async () => {
      try {
        setLoading(true);
        const res = await api.get(
          `companyblog/search/?q=${encodeURIComponent(keyword)}`
        );
        setResults(res.data.data);
      } catch (error) {
        console.error("Search failed", error);
      } finally {
        setLoading(false);
      }
    };

    fetchResults();
  }, [keyword]);

  if (loading) return <p className="text-center mt-5">Searching…</p>;

  const isEmpty =
    !results.products.length &&
    !results.brands.length &&
    !results.testimonials.length &&
    !results.teams.length;


  return (
    <>
      <Navbar />
        <hr></hr>
         <div className="container py-5">
      <h4 className="mb-4">
        Search results for <strong>"{keyword}"</strong>
      </h4>

      {isEmpty && <p>No results found.</p>}

        {/* PRODUCTS */}
        {results.products.length > 0 && (
        <>
            <h5 className="mt-4 mb-3">Products</h5>
            <div className="row">
            {results.products.map((item) => (
                <div className="col-md-4 mb-4" key={item.id}>
                <a
                    href={item.product_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                >
                    <div className="card h-100">
                    <img
                        src={item.product_image}
                        alt={item.product_name}
                        className="card-img-top"
                        style={{ height: 180, objectFit: "contain" }}
                    />
                    <div className="card-body">
                        <h6>{item.product_name}</h6>
                    </div>
                    </div>
                </a>
                </div>
            ))}
            </div>
        </>
        )}


      {/* BRANDS */}
      {results.brands.length > 0 && (
        <>
          <h5 className="mt-4 mb-3">Brands</h5>
          <div className="row">
            {results.brands.map((brand) => (
              <div className="col-md-3 mb-4" key={brand.id}>
                <div className="card h-100 text-center">
                  <img
                    src={brand.brand_image}
                    alt={brand.brand_name}
                    className="card-img-top"
                    style={{ height: 120, objectFit: "contain" }}
                  />
                  <div className="card-body">
                    <h6>{brand.brand_name}</h6>
                  </div>
                </div>
              </div>
            ))}
          </div>
                 </>
      )}

      {/* TESTIMONIALS */}
      {results.testimonials.length > 0 && (
        <>
          <h5 className="mt-4 mb-3">Testimonials</h5>
          {results.testimonials.map((t) => (
            <div className="card mb-3" key={t.id}>
              <div className="card-body">
                <p>"{t.feedback}"</p>
                <small>
                  — {t.person_name}, {t.person_occupation}
                </small>
              </div>
            </div>
          ))}
        </>
      )}

      {/* TEAMS */}
      {results.teams.length > 0 && (
        <>
          <h5 className="mt-4 mb-3">Our Team</h5>
          <div className="row">
            {results.teams.map((m) => (
              <div className="col-md-3 mb-4" key={m.id}>
                <div className="card text-center h-100">
                  <img
                    src={m.image}
                    alt={m.name}
                    className="card-img-top"
                    style={{ height: 160, objectFit: "cover" }}
                  />
                  <div className="card-body">
                    <h6>{m.name}</h6>
                    <small>{m.position}</small>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
    <hr />
      <Footer />
    </>
  );
};

export default SearchPage;
